export type ViewerGroupOption = { id: string; label: string };

/**
 * Options for the queue-viewer picker.
 *
 * Until the team list has loaded, the saved ids stay selected under a fallback
 * label. Dropping them would show an empty picker and a later edit would clear
 * the grant.
 */
export function viewerGroupPickerState(input: {
  viewerUserGroupIds: readonly string[];
  userGroups: readonly { id: string; name: string }[] | undefined;
  savedTeamLabel: string;
}): { options: ViewerGroupOption[]; selected: ViewerGroupOption[] } {
  if (input.userGroups == null) {
    const selected = input.viewerUserGroupIds.map((id) => ({
      id,
      label: input.savedTeamLabel,
    }));
    return { options: selected, selected };
  }
  const selectedIds = new Set(input.viewerUserGroupIds);
  const options = input.userGroups.map((group) => ({
    id: group.id,
    label: group.name,
  }));
  return {
    options,
    selected: options.filter((option) => selectedIds.has(option.id)),
  };
}
